/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_EyebrowInputs */

const en_directory_promotion_eyebrow = /** @type {(inputs: Directory_Promotion_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsor plan`)
};

const zh_directory_promotion_eyebrow = /** @type {(inputs: Directory_Promotion_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsor 套餐`)
};

/**
* | output |
* | --- |
* | "Sponsor plan" |
*
* @param {Directory_Promotion_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_eyebrow = /** @type {((inputs?: Directory_Promotion_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_eyebrow(inputs)
	return zh_directory_promotion_eyebrow(inputs)
});
export { directory_promotion_eyebrow as "directory.promotion.eyebrow" }